module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-e18bbf.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/glyphicons-halflings-regular.ttf
 ** module id = 513
 ** module chunks = 2
 **/